import { MyTicketsView as SdkMyTicketsView } from '@reqdesk/sdk-react'

interface MyTicketsViewProps {
  /** Kept for back-compat with v1.3 hosts — sdk-react reads the
   *  projectId from context (configured by SdkReactBridge). */
  projectId?: string
  onSelectTicket: (ticketId: string) => void
  isAuthenticated?: boolean
  userEmail?: string
}

export function MyTicketsView({ onSelectTicket, isAuthenticated, userEmail }: MyTicketsViewProps) {
  return (
    <SdkMyTicketsView
      onSelectTicket={onSelectTicket}
      isAuthenticated={isAuthenticated}
      userEmail={userEmail}
    />
  )
}
